import React, {Component} from "react";
import PropTypes from "prop-types";
import {defaultProps, propTypes} from "react-props-decorators";
import L from "leaflet";
import ReactPopup from "react-leaflet-popup";
import ReactDOMServer from 'react-dom/server';
import _ from 'lodash';
import $ from 'jquery';

import "lib/marker.slideto";
import "leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

import "leaflet/dist/leaflet.css";
import "./leaflet.less";
import MapComponent from "../../ui/map";
import Button from "components/ui/button";
import MapVehicleClusterIcon from "components/ui/map-vehicle-cluster-icon";
import MapVehicleIcon from "components/ui/map-vehicle-icon";
import VehicleMarkerPopup from "components/modules/map/elements/popup/index";
import StopPointsMtaLayer from "components/ui/map/layers/stop-points-mta";
import {api} from "helpers/api";
import {makeResponse} from "helpers/response";

const avatar = '/static/img/avatar.jpg';

@propTypes({
    telematics: PropTypes.object,
    vehicles: PropTypes.object,
    clusters: PropTypes.array,
    onClusterRendered: PropTypes.func,
    onZoom: PropTypes.func,
})

@defaultProps({
    onClusterRendered: () => {
    },
    onZoom: () => {
    },
})
export default class LeafletComponent extends Component {

    animationForecastSpeed = 1000;
    slideLimit = 1000;

    markersLayer = null;
    markers = null;
    clustersLayer = null;
    forecastLayer = null;
    allMarkers = {};
    popup = null;

    componentDidMount() {
        const map = this.refs.map.getWrappedInstance().map;

        this.markersLayer = new L.layerGroup().addTo(map);

        this.markers = new L.layerGroup();
        this.markersLayer.addLayer(this.markers);

        this.clustersLayer = new L.layerGroup();
        this.markersLayer.addLayer(this.clustersLayer);

        this.forecastLayer = new L.layerGroup().addTo(map);
    }

    componentWillReceiveProps(props) {
        /*if (props.params.type !== 'bus') {
            return;
        }*/
        this.removeUnusedMarkers(props.telematics.keySeq().toArray());

        this.drawForecast(props);
        let i = 0;
        for (let deviceId of props.telematics.keys()) {
            const device = new TelematicsDevice(
                deviceId, props.telematics.get(deviceId)
            );

            let marker = this.allMarkers[deviceId];

            if (!marker) {
                this.allMarkers[deviceId] = marker = this.makeMarker(device);
                this.markers.addLayer(marker);
                i++;
            } else {
                try {
                    this.moveMarkerToNewPlace(marker, device);
                    /*marker.on('click', (e) => {
                        this.loadPopupData(device, e.target)
                    });*/
                } catch (e) {
                }
            }
            /*if (!marker.getTooltip() || !marker.isTooltipOpen()) {
                marker.unbindTooltip();
                const vehicle = this.props.vehicles[device.id];
                let tooltip = [];
                if (vehicle) {
                    tooltip.push(`Госномер: ${vehicle.state_number}`);
                }
                tooltip.push(`Скорость: ${device.speed} км/ч`);
                tooltip.push(`Азимут: ${device.course}°`);

                marker.bindTooltip(tooltip.join('<br/>'), {sticky: true});
            }*/
        }

        this.clustersLayer.clearLayers();

        _.each(props.clusters, (cluster) => {
            const clusterInfo = cluster[2];
            const marker = new L.marker([cluster[0], cluster[1]], {
                keyboard: false,
                interactive: false,
                icon: this.createClusterIcon(clusterInfo),
            });
            this.clustersLayer.addLayer(marker);
        });
    }

    drawForecast(props) {
        if (!this.props.location.query.debug) {
            return;
        }

        this.forecastLayer.clearLayers();

        for (let deviceId of props.telematics.keys()) {
            const device = new TelematicsDevice(
                deviceId, props.telematics.get(deviceId)
            );

            const forecast = device.forecast;
            if (!_.isArray(forecast) || (forecast.length === 0)) {
                continue;
            }

            const object = new L.polyline(forecast, {
                color: '#ff0000',
                opacity: 0.6,
            });
            this.forecastLayer.addLayer(object);
        }
    }

    createClusterIcon(clusterInfo) {
        const html = ReactDOMServer.renderToStaticMarkup(<MapVehicleClusterIcon info={clusterInfo}/>);

        return new L.DivIcon({
            html: html,
            className: 'cluster',
            iconSize: new L.Point(72, 72),
            iconAnchor: new L.Point(36, 36),
        });
    }

    createMarkerIcon(device) {
        const html = ReactDOMServer.renderToStaticMarkup(<MapVehicleIcon device={device} direction={device.course}/>);

        let type = 'bus';
        switch (device.type) {
            case 'road':
                type = 'road';
                break;
            case 'trash':
                type = 'trash';
                break;
            case 'control':
                type = 'control';
                break;
            case 'school':
                type = 'school';
                break;
        }

        let className = `marker marker_type_${type}`;
        return new L.DivIcon({
            html: html,
            className: className,
            iconSize: new L.Point(46, 46),
            iconAnchor: new L.Point(23, 23),
        });
    }

    removeUnusedMarkers(markers) {
        const unused = _.difference(_.keys(this.allMarkers), markers);

        _.each(unused, (deviceId) => {
            const marker = this.allMarkers[deviceId];
            this.markers.removeLayer(marker);
            delete this.allMarkers[deviceId];
        });
    }

    getBoundingBox() {
        return this.refs.map.getWrappedInstance().getBoundingBox();
    }

    getMapSize() {
        return this.refs.map.getWrappedInstance().getMapSize();
    }

    getZoom() {
        return this.refs.map.getWrappedInstance().getZoom();
    }

    makeMarker(device) {
        const marker = L.marker([device.lat, device.lng], {
            icon: this.createMarkerIcon(device),
            deviceId: device.id,
            riseOnHover: true,
        });

        marker.position = [device.lat, device.lng];
        marker.course = device.course;

        marker.on('click', (e) => {
            this.loadPopupData(device.id, e.target)
        });

        const forecast = device.forecast;

        if (_.isArray(forecast) && (forecast.length > 0)) {
            marker.animation = setTimeout(this.animateMarker.bind(this, marker, forecast, device.speed), this.animationForecastSpeed);
        }

        return marker;
    }

    moveMarkerToNewPlace(marker, device) {
        const latlng = {
            lat: marker.position[0],
            lng: marker.position[1],
        };

        const precision = 6;
        // если положение машины изменилось, то плавно передвигаем
        if (!((_.round(latlng.lat, precision) == _.round(device.lat, precision)) && (_.round(latlng.lng, precision) == _.round(device.lng, precision)))) {
            const icon = marker._icon;
            if (icon) {
                let normalMarkerCourse = marker.course % 360;
                if (normalMarkerCourse < 0) {
                    normalMarkerCourse += 360;
                }

                let diff = _.toNumber(device.course - normalMarkerCourse);
                if (diff > 180) {
                    diff -= 360;
                } else if (diff < -180) {
                    diff += 360;
                }
                const course = _.toNumber(marker.course) + diff;
                $(icon).find('.marker__direction').css('transform', `rotate(${course}deg)`);
            }
            const forecast = device.forecast;

            marker.slideCancel();

            marker.position = [device.lat, device.lng];
            if (!_.isArray(forecast) || (forecast.length === 0)) {
                this.slideTo(marker, [device.lat, device.lng], 4000);
            } else {
                marker.animation && clearTimeout(marker.animation);

                //this.slideTo(marker, [device.lat, device.lng], this.animationForecastSpeed);
                marker.animation = setTimeout(this.animateMarker.bind(this, marker, forecast, device.speed), this.animationForecastSpeed);
            }
        }
    }

    slideTo(marker, coordinates, duration) {
        try {
            if (marker.getLatLng().distanceTo(coordinates) <= this.slideLimit) {
                marker.slideTo(coordinates, {duration});
                return;
            }
        } catch (e) {
        }

        marker.setLatLng(coordinates);
    }

    animateMarker(marker, forecast, speed, index = 0) {
        const coordinates = forecast[index];
        if (coordinates) {
            this.slideTo(marker, coordinates, this.animationForecastSpeed);
            marker.animation = setTimeout(this.animateMarker.bind(this, marker, forecast, speed, index + 1), this.animationForecastSpeed);
        } else {
            marker.animation = null;
        }
    }

    async loadPopupData(deviceId, marker) {
        const device = new TelematicsDevice(
            deviceId, this.props.telematics.get(deviceId)
        );

        if (marker._popup !== undefined) {
            marker.unbindPopup();
        }

        marker.closePopup();

        const response = await makeResponse(() => {
            return api.vehicles.getVehicleList({
                filters: {
                    withCurrentBnsoNumber: [device.id],
                },
            })
        });

        if (response.isOk) {
            if (response.payload.items.length > 0) {
                marker.bindPopup(
                    this.renderPopup(device, _.first(response.payload.items), ::marker.closePopup)
                );
                marker.openPopup();
            }
        } else {
            response.showErrors();
        }
    }

    render() {
        return (
            <MapComponent
                ref="map"
                onZoom={this.props.onZoom}
                showLayers={false}
                showSearch={false}
                layers={[
                    {
                        uuid: 'vehicles',
                        title: '<img src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDM2MS4xMTggMzYxLjExOCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzYxLjExOCAzNjEuMTE4OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPGcgaWQ9Il94MzJfMzcuX0xvY2tlZCI+CgkJPGc+CgkJCTxwYXRoIGQ9Ik0yNzQuNzY1LDE0MS4zVjk0LjIwNUMyNzQuNzY1LDQyLjE3MiwyMzIuNTgzLDAsMTgwLjU1OSwwYy01Mi4wMzIsMC05NC4yMDUsNDIuMTcyLTk0LjIwNSw5NC4yMDVWMTQxLjMgICAgIGMtMTcuMzQsMC0zMS40LDE0LjA2LTMxLjQsMzEuNHYxNTcuMDE2YzAsMTcuMzQ0LDE0LjA2LDMxLjQwMiwzMS40LDMxLjQwMmgxODguNDExYzE3LjM0MSwwLDMxLjM5OC0xNC4wNTksMzEuMzk4LTMxLjQwMlYxNzIuNyAgICAgQzMwNi4xNjQsMTU1LjM2LDI5Mi4xMDYsMTQxLjMsMjc0Ljc2NSwxNDEuM3ogTTExNy43NTYsOTQuMjA1YzAtMzQuNjksMjguMTItNjIuODAzLDYyLjgwMy02Mi44MDMgICAgIGMzNC42ODUsMCw2Mi44MDUsMjguMTEyLDYyLjgwNSw2Mi44MDNWMTQxLjNIMTE3Ljc1NlY5NC4yMDV6IE0yNzQuNzY1LDMyOS43MTVIODYuMzU0VjE3Mi43MDhoMTg4LjQxMVYzMjkuNzE1eiAgICAgIE0xNjQuODU4LDI2Mi41NTh2MjAuMDU0YzAsOC42NjQsNy4wMzUsMTUuNzAxLDE1LjcwMSwxNS43MDFjOC42NjQsMCwxNS43MDEtNy4wMzcsMTUuNzAxLTE1LjcwMXYtMjAuMDU0ICAgICBjOS4zMzctNS40NDEsMTUuNzAxLTE1LjQ1NiwxNS43MDEtMjcuMDQ2YzAtMTcuMzQ4LTE0LjA2Mi0zMS40MS0zMS40MDItMzEuNDFjLTE3LjM0LDAtMzEuNCwxNC4wNjItMzEuNCwzMS40MSAgICAgQzE0OS4xNTksMjQ3LjEwMiwxNTUuNTE3LDI1Ny4xMTcsMTY0Ljg1OCwyNjIuNTU4eiIgZmlsbD0iI0ZGRkZGRiIvPgoJCTwvZz4KCTwvZz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K" /> ТС',
                        layer: this.markersLayer,
                    }
                ]}
                withRouting={this.props.params.type === 'bus'}
                onStopPointClick={this.props.onStopPointClick}
                onStopPointScheduleClick={this.props.onStopPointScheduleClick}
                onStopPointFromHereClick={this.props.onStopPointFromHereClick}
                onStopPointToHereClick={this.props.onStopPointToHereClick}
            >
                {this.props.children}
                {(this.refs.map && (this.props.params.type === 'bus')) ? (
                    <StopPointsMtaLayer
                        map={this.refs.map.getWrappedInstance()}
                        leafletMap={this.refs.map.getWrappedInstance().map}
                        selectedStopPoint={this.props.selectedStopPoint}
                        selectedStopPoints={this.props.selectedStopPoints}
                        onStopPointClick={this.props.onStopPointClick}
                        onStopPointScheduleClick={this.props.onStopPointScheduleClick}
                        onStopPointFromHereClick={this.props.onStopPointFromHereClick}
                        onStopPointToHereClick={this.props.onStopPointToHereClick}
                    />
                ) : null}
            </MapComponent>
        );
    }

    renderPopup(device, vehicle, onClose) {
        if (!vehicle) {
            return;
        }
        let vehicleModel = null;

        if (window.vehicle_types) {
            vehicle.vehicle_type =  _.get(_.find(window.vehicle_types, {uuid: vehicle.vehicle_type_uuid}), 'name');
        }

        if (vehicle.vehicle_model_uuid) {
            vehicleModel = _.get(_.find(this.props.data.vehicle_models, {uuid: vehicle.vehicle_model_uuid}), 'name');
        }
        let vehicleMark = null;
        if (vehicle.vehicle_mark_uuid) {
            vehicleMark = _.get(_.find(this.props.data.vehicle_marks, {uuid: vehicle.vehicle_mark_uuid}), 'name');
        }
        const vehicleCarrier = _.get(this.props.data.carriers, vehicle.unit_uuid);

        return new ReactPopup({
            reactComponent: VehicleMarkerPopup,
            reactComponentProps: {
                ...this.props,
                device,
                vehicle,
                vehicleModel,
                vehicleMark,
                vehicleCarrier,
                onClose,
            },
            minWidth: 434,
            maxWidth: 434,
            offset: new L.Point(3, -250),
        });
    }
}

class TelematicsDevice {

    /**
     * @param {String} id
     * @param {Object} device
     */
    constructor(id, device) {
        this.__id = id;
        this.__lat = _.get(device, 0);
        this.__lng = _.get(device, 1);
        this.__speed = _.get(device, 2);
        this.__course = _.get(device, 3);
        this.__type = _.get(device, 4);
        this.__time = _.get(device, 5);
        this.__forecast = _.get(device, 6);
    }

    /**
     * @return {String}
     */
    get id() {
        return this.__id;
    }

    /**
     * @return {Number}
     */
    get lat() {
        return this.__lat;
    }

    /**
     * @return {Number}
     */
    get lng() {
        return this.__lng;
    }

    /**
     * @return {Number}
     */
    get course() {
        return this.__course;
    }

    /**
     * @return {Number}
     */
    get speed() {
        return this.__speed;
    }

    /**
     * @return {String}
     */
    get type() {
        return this.__type;
    }

    /**
     * @return {String}
     */
    get time() {
        return this.__time;
    }

    get forecast() {
        return this.__forecast;
    }
}



// WEBPACK FOOTER //
// ./src/components/modules/map/leaflet.js